<template>
  <div class="IncomeLedger">
    <div class="flex">
      <div class="flex-fixed">
        <div class="inline bold">기간</div>
        <APeriodSelector
          ref="period"
          class="inline ml-default"
          :value="search_period"
          :disabled="disabled"
          hide-select
          @change="handleChangePeriod"
        />
      </div>
      <div class="flex-auto">
        <el-button
          type="primary"
          size="mini"
          round
          v-shortkey="['f5']"
          @shortkey.native="handleClickSearch"
          @click="handleClickSearch"
          >{{ $t("button.search") }}(F5)</el-button
        >
      </div>
    </div>
    <div class="flex-column align-center" v-if="!disableDownload">
      <h1>검색이 완료되었습니다.</h1>
      <h1>
        <span class="download-link" @click="handleClickExcel">여기</span>를 눌러
        다운로드 해 주세요.
      </h1>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { account_form } from "@/common/mixins/account_form";
import { company_info } from "@/common/mixins/company_info";
import Xlsx from "xlsx";

export default {
  name: "IncomeLedger",
  mixins: [account_form, company_info],
  data() {
    return {
      company: {
        show_pyung_processing_cost: false,
        income_trade_print_pyung: false,
      },
      title: this.$t("title.sale_ledger"),
      search_period: { value: "1m" },
      period: {},
      loading: false,
      items: [],
      items_original: [],
      collect_price: 0,
      discount_price: 0,
      expense_price: 0,
      tax_price: 0,
      selection: [],
      selectedData: [],
      selectedDataTradePrint: [],
      dialog_visible: false,
      dialog2_visible: false,
      sum_flag: false,
      disableDownload: true,
      loadingDownload: false,
    };
  },
  props: {
    customer: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    customer() {
      this.disableDownload = true;
    },
    table_config() {
      this.loadConfig()
    },
  },
  computed: {
    ...mapGetters(["table_product", "table_product_category"]),
    showPyungProcessingCost() {
      return this.company.show_pyung_processing_cost;
    },
    isTotalPyung() {
      return this.company.income_trade_print_pyung;
    },
    product_stat() {
      let product_categories = JSON.parse(
        JSON.stringify(this.table_product_category)
      );
      let stat_flag_list = [];
      product_categories.forEach((item) => {
        if (item.stat_flag === "Y") {
          stat_flag_list.push({
            id: stat_flag_list.length + 1,
            label: item.name,
            categories: [item.id],
          });
        }
      });
      return stat_flag_list;
    },
  },
  mounted() {
    this.loadConfig()
  },
  methods: {
    loadData(is_autoselect = true) {
      if (!this.customer) {
        return;
      }
      this.loading = true;
      this.collect_price = 0;
      this.discount_price = 0;
      this.expense_price = 0;
      this.tax_price = 0;
      this.items = [];
      this.api
        .selectIncomeCustomerDate(this.customer.id, this.period.startDate)
        .then((res) => {
          if (res.error !== this.system.noError) {
            this.util.notify_response_error(this, this.title, res);
          }
          this.last_trade = res.data;
          this.api
            .listIncomeCustomer(this.customer.id, this.period)
            .then((res) => {
              this.loading = false;
              if (res.error !== this.system.noError) {
                this.util.notify_response_error(this, this.title, res);
                return;
              }
              this.disableDownload = false;
              this.items_original = res.data;
              this.organizeData(is_autoselect);
            });
        });
    },
    /**
     * 데이터에 소계등을 추가한다.
     */
    organizeData(is_autoselect) {
      let items = Object.assign([], this.items_original);
      let collect_price = 0;
      let discount_price = 0;
      let expense_price = 0;
      let tax_price = 0;
      items.forEach((item) => {
        if (item.type_flag === "2") {
          item.product_name = "수금액";
          if (item.collect_way_flag == "2") {
            item.size = this.getBankAccountName(item.account_id);
          } else {
            item.size = this.system.options.resolve_collect_way_flag(
              item.collect_way_flag
            );
          }
          if (item.discount_price > 0) {
            item.unit_name = "DC";
            item.cost = item.discount_price;
          }
          item.price = item.collect_price;
          item.transaction_flag = item.collect_transaction_flag;
          collect_price += item.price;
          discount_price += item.discount_price;
        } else {
          item.transaction_flag = item.sale_transaction_flag;
          expense_price += item.price;
          tax_price += item.tax;
        }
      });
      // 월별 소계 추가
      let month_old = "";
      let month_cur = "";
      let month_supply_price = 0;
      let month_pyung = 0;
      let month_item_processing_cost = 0;
      let month_tax = 0;
      let month_price = 0;
      let month_amount = 0;
      // 기간누계 추가
      let total_supply_price = 0;
      let total_pyung = 0;
      let total_item_processing_cost = 0;
      let total_tax = 0;
      let total_price = 0;
      let total_amount = 0;
      // 품목계 추가
      let item_product_stat = {};
      this.product_stat.forEach((s) => {
        item_product_stat[s.id] = 0;
      });
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        month_cur = item.deal_date.substring(0, 7);
        if (month_old !== month_cur) {
          if (month_old !== "") {
            items.splice(i, 0, {
              sum_row: true,
              contract_code: "소 계",
              item_pyung: this.isTotalPyung ? month_pyung.toFixed(2) : '',
              amount: month_amount,
              supply_price: month_supply_price,
              item_processing_cost: month_item_processing_cost,
              tax: month_tax,
              price: month_price,
            });
            month_amount = 0;
            month_supply_price = 0;
            month_pyung = 0;
            month_item_processing_cost = 0;
            month_tax = 0;
            month_price = 0;
            i++;
          }
          month_old = month_cur;
        }
        if (item.type_flag === "1") {
          month_supply_price += item.supply_price;
          month_pyung += Number(this.isGlass(item,item.size)) * item.amount;
          month_item_processing_cost += item.item_processing_cost;
          month_tax += item.tax;
          month_price += item.price;
          month_amount += item.amount;
          total_supply_price += item.supply_price;
          total_pyung += Number(this.isGlass(item,item.size)) * item.amount;
          total_item_processing_cost += item.item_processing_cost
          total_tax += item.tax;
          total_price += item.price;
          total_amount += item.amount;
        }

        let product_id = item["product_id"];
        let product = this.table_product.find(
          (product_item) => product_item.id === product_id
        );
        // 제품 통계를 업데이트
        if (product) {
          this.product_stat.forEach((product_stat_item) => {
            let listCategory = this.getProductCategories(product.categories);
            if (
              product_stat_item.categories.every(
                (category_item) => listCategory.indexOf(category_item) > -1
              )
            ) {
              item_product_stat[product_stat_item.id] += item["amount"];
            }
          });
        }
      }
      if (items.length > 0 && !items[items.length - 1].sum_row) {
        //마지막 행이 소계가 아니라면
        items.splice(items.length + 1, 0, {
          sum_row: true,
          contract_code: "소 계",
          item_pyung: this.isTotalPyung ? month_pyung.toFixed(2) : '',
          amount: month_amount,
          supply_price: month_supply_price,
          item_processing_cost: month_item_processing_cost,
          tax: month_tax,
          price: month_price,
        });
      }
      // 기간누계 추가
      items.splice(items.length + 2, 0, {
        sum_row: true,
        total_sum: true,
        contract_code: "기간 누계",
        product_name: this.getProductStat(item_product_stat),
        item_pyung: this.isTotalPyung ? total_pyung.toFixed(2) : '',
        item_processing_cost: total_item_processing_cost,
        amount: total_amount,
        supply_price: total_supply_price,
        tax: total_tax,
        price: total_price,
      });
      //상단에 전기미수금 추가
      let last = { id: -1, product_name: "전 기 미 수 금", type_flag: "3" };
      last.balance = this.last_trade ? this.last_trade.balance : 0;
      items.splice(0, 0, last);

      this.collect_price = collect_price;
      this.discount_price = discount_price;
      this.expense_price = expense_price;
      this.tax_price = tax_price;
      this.items = items;
      if (!is_autoselect) {
        return;
      }
      this.$nextTick(() => {
        let items = this.items.filter(
          (item) => item.transaction_flag && item.transaction_flag !== "Y"
        );
        if (items.length < 1) {
          return;
        }
      });
    },
    handleChangePeriod(period) {
      if (!period.valid) return;
      this.period = period;
      this.disableDownload = true;
    },
    handleClickExcel() {
      this.loadingDownload = true;
      const excelItems = [];
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        let additionalRowTotalPyung = {
          총평수: this.isGlassTotalPyung(item, item.size),
        }
        let additionalRows = {
          평단가: this.util.numberFormat(null, null, item.pyung_cost),
          가공비: this.util.numberFormat(null, null, item.item_processing_cost),
        }
        if(!this.isTotalPyung) additionalRowTotalPyung = {}
        if(!this.showPyungProcessingCost) additionalRows = {}
        excelItems.push({
          매출일: item.deal_date,
          수주번호: item.contract_code,
          품목: item.product_name,
          규격: item.size,
          평: this.isGlass(item, item.size),
          수량: this.util.numberFormat(null, null, item.amount),
          단위: item.unit_name,
          ...additionalRowTotalPyung,
          단가: this.util.numberFormat(null, null, item.cost),
          ...additionalRows,
          공급가액: this.util.numberFormat(null, null, item.supply_price),
          세액: this.util.numberFormat(null, null, item.tax),
          금액: this.util.numberFormat(null, null, item.price),
          미수금: this.util.numberFormat(null, null, item.balance),
          담당자: item.charger,
          현장: item.field,
          비고: item.desc,
          등록자: item.created_user_name,
          수정자: item.modified_user_name,
        });
      }
      const workBook = Xlsx.utils.book_new();
      const workSheet = Xlsx.utils.json_to_sheet(excelItems);
      Xlsx.utils.book_append_sheet(workBook, workSheet, "file");
      Xlsx.writeFile(workBook, "file.csv");
      this.loadingDownload = false;
    },
    isGlass(row, value) {
      if(row.pyung) return row.pyung;
      if (row.product_kind === "GLASS" && row.size) {
        if (value.includes("/")) value = value.split("/")[0];
        const [horizontal, vertical] = value.split("*").map((x) => Number(x));
        const return_value =
          this.util.calculatePyung(horizontal, vertical, true)
        return isNaN(return_value) ? "" : return_value < 3 ? 3 : return_value;
      }
      return "";
    },
    isGlassTotalPyung(row, value) {
      if(row.item_pyung) return row.item_pyung;
      if (row.product_kind === "GLASS" && row.size) {
        if (value.includes("/")) value = value.split("/")[0];
        const [horizontal, vertical] = value.split("*").map((x) => Number(x));
        let return_value = this.util.calculatePyung(horizontal, vertical, true)
        return isNaN(return_value) ? "" : ((return_value < 3 ? 3 : return_value) * row.amount).toFixed(2);
      }
      return "";
    },
    getProductCategories(categories) {
      let ret = [];
      categories.forEach((c) => {
        ret.push(c.product_category_id);
      });
      return ret;
    },
    getProductStat(product_stat) {
      let ret = "";
      this.product_stat.forEach((s) => {
        ret += s.label + ":" + product_stat[s.id] + " ";
      });
      return ret;
    },
    handleClickSearch() {
      this.loadData();
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/css/_variables.scss";

.IncomeLedger {
  .balance {
    color: $color-primary !important;
  }
  .el-table__row.collect-row {
    .product_name,
    .unit_name,
    .cost,
    .suppoy_price,
    .price {
      color: $color-danger;
    }
  }
  .el-table__row.sum-row {
    background: lightgray;
  }
  .el-table__row.warning-row {
    height: 30px;
  }
  .download-link {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
